exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vehicle-checkbox-column{width:20px}.vehicles-empty-text{color:#a94442 !important}.unit-base-field-container{max-height:50rem;overflow-y:scroll}.unit-base-field-code{opacity:.3}.unit-base-field-table{margin-bottom:0px !important}.selected-filter{cursor:pointer}.selected-filter a.active{opacity:100%}.selected-filter a.active i{color:red}.selected-filter a.inactive{opacity:40%}\n", ""]);

// exports
